import type { TRouteId, TParamsMapper } from './types';
import ROUTE_IDS from '$src/generated/routeIds';
import type { TRouteParams } from '@casumo/fabric-fundamentals';

const SLUGIFIED_ROUTES_INTERCEPTORS: Record<string, [string, TParamsMapper]> = {
    PROMOTION_DETAILS: [
        ROUTE_IDS.PROMOTION_DETAILS,
        ({ slug: promotionSlug }) => ({ promotionSlug })
    ],
    PLAY: [ROUTE_IDS.PLAY, ({ slug: gameSlug }) => ({ gameSlug })],
    PRACTICE: [ROUTE_IDS.PRACTICE, ({ slug: gameSlug }) => ({ gameSlug })]
};

const identity: TParamsMapper = (x) => x;

export const intercept = (
    routeId: string,
    params: TRouteParams
): [TRouteId | string, TRouteParams] => {
    const [potentialRoute, paramsConverter = identity] = SLUGIFIED_ROUTES_INTERCEPTORS[routeId] ?? [
        ROUTE_IDS[routeId as TRouteId] || routeId,
        identity
    ];

    return [potentialRoute, paramsConverter(params)];
};
